exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th[data-v-e896f524]{border-bottom:1px solid #e0e0e0;font-weight:600}td[data-v-e896f524]{border-bottom:1px solid #f0f0f0}.payment-errors-modal[data-v-e896f524]{display:inline-block;max-width:90vw}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e896f524","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/BillsList/PaymentErrorsModal.vue
// module id = TVzB
// module chunks = 0